import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

interface RequireProfileProps {
  children: React.ReactNode;
}

export default function RequireProfile({ children }: RequireProfileProps) {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function checkProfile() {
      if (authLoading) return;

      if (!user) {
        setChecking(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_profiles')
          .select('onboarding_completed')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error checking profile:', error);
          setChecking(false);
          return;
        }

        if (!data || !data.onboarding_completed) {
          navigate('/onboarding');
          return;
        }

        setChecking(false);
      } catch (err) {
        console.error('Error checking profile:', err);
        setChecking(false);
      }
    }

    checkProfile();
  }, [user, authLoading, navigate]);

  if (authLoading || checking) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'var(--bg)',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: '48px',
              height: '48px',
              border: '4px solid #e5e7eb',
              borderTopColor: 'var(--brand)',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
              margin: '0 auto 16px',
            }}
          />
          <p style={{ color: 'var(--muted)', fontSize: '14px' }}>Cargando...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
